import find from 'lodash/find';

export const ROLES = {
  CLAIMS: {
    NSD_ADMIN: {
      id: 14
    },
    DEALER_PORTAL_ADMIN: {
      id: 24
    },
    DEALER_PORTAL_USER: {
      id: 29
    },
    DEALER_PORTAL_CASHIER: {
      id: 58
    },
    GLASS_CLAIM_PROCESSOR: {
      id: 266
    },

  }
};
export const GlassRoleNames = [
  'Glass Claims Processor',
  'Glass Claims View Only'
]

export const DealerControllerRoleNames = [
  'Dealer Controller',
  'Dealer Controller View Only'

]

export const DealerClaimRoleNames = [
  'Dealer Portal Admin',
  'Dealer Portal User'
]
export const RemittanceRoleNames = ['Dealer Controller']

export const PolicySearchRoleNames = [
  'Dealer Portal Admin',
  'Dealer Portal User',
  'NSD Admin',
  'Admin',
  'Dealer Controller',
  'Dealer Controller View Only'
]

export const isRoamingAdmin = (userDefinedRoles) => {
  let hasRoleAccess = find(userDefinedRoles, function (obj) {
    return obj?.name?.toLowerCase() === 'dealer portal roaming admin';
  });
  return hasRoleAccess != undefined;
};

export default (userDefinedRoles, role) => {
  let hasRoleAccess = find(userDefinedRoles, function (obj) {
    return obj.id === role.id;
  });
  return hasRoleAccess != undefined;
};
